import { render, staticRenderFns } from "./myc-big-button.vue?vue&type=template&id=81704db0"
import script from "./myc-big-button.vue?vue&type=script&lang=js"
export * from "./myc-big-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports